import React from 'react';
import styled from 'styled-components';
import { colorMap, colors } from '../../../../globalStyles';
import { InlineSVG } from '../../../../Components/Icons';

type InsightsButtonProps = {
  onOpenInsights: () => void;
};

// Hidden for PDE-1532 rather than removed: the button and the modal it opens stay wired so the
// control can come back by flipping this alone. Since PDE-1566 the Beacon student detail modal shows
// the insights inline under its header instead, so only the patient profile's Beacon tab still
// renders this. If that tab is removed, this button and the modal it opens can go with it.
export const INSIGHTS_BUTTON_VISIBLE = false;

export const InsightsButton = ({ onOpenInsights }: InsightsButtonProps) => (
  <InsightsBtn type="button" onClick={onOpenInsights}>
    <InlineSVG icon="magic-wand" size={20} fill={colors.white} />
    Insights &amp; Recommendations
  </InsightsBtn>
);

const InsightsBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
  padding: 12px 22px;
  border: none;
  border-radius: 24px;
  background-color: ${colors.primary};
  color: ${colors.white};
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${colorMap.primary[0]};
  }

  &:focus-visible {
    outline: 2px solid ${colors.text};
    outline-offset: 2px;
  }

  @media (max-width: 959px) {
    margin-left: 0;
    flex-basis: 100%;
    justify-content: center;
  }
`;
